import { BigSaleTextIcon, RedCoupon16x16Icon } from '~/assets/icons';

export function BigSaleLabel() {
  return (
    <div className="flex items-center gap-x-2">
      <RedCoupon16x16Icon />
      <BigSaleTextIcon />
    </div>
  );
}
